// Custom alpine directives go here
//
// For example, `x-uppercase`:
//
// Alpine.directive('uppercase', (el) => {
//   el.textContent = el.textContent.toUpperCase();
// });
Alpine.magic('fetchedSection', () => {
  return (url, selector) => {
    return async () => {
      return await fetchSectionHTML(url, selector);
    };
  };
});

// "Complete your routine" bundle picker for the complementary-products PDP block
// (snippets/product-block-complementary-products.liquid, P2-08). Registered here
// rather than in its own asset because that block is often injected via an async
// `x-html` fetch after Alpine has already started — a <script> tag inside that
// fetched HTML never runs. This file loads globally before Alpine.start(), so the
// component is always defined by the time the injected `x-data` is initialised.
// The savings percentage is copy the merchant types into the block settings — this
// component never invents or applies a discount.
Alpine.data('ThemeComponent_ComplementaryBundle', ({ items }) => ({
  items: items || [],
  selected: (items || [])
    .filter((item) => item.available)
    .map((item) => item.variantId),
  loading: false,
  addedToCart: false,
  error: '',

  toggle(variantId) {
    const index = this.selected.indexOf(variantId);
    if (index === -1) {
      this.selected.push(variantId);
    } else {
      this.selected.splice(index, 1);
    }
  },

  isSelected(variantId) {
    return this.selected.includes(variantId);
  },

  get subtotal() {
    return this.items
      .filter((item) => this.selected.includes(item.variantId))
      .reduce((sum, item) => sum + item.price, 0);
  },

  get selectedCount() {
    return this.selected.length;
  },

  formatMoney(cents) {
    return typeof window.formatMoney === 'function'
      ? window.formatMoney(cents)
      : '$' + (cents / 100).toFixed(2);
  },

  addSelected() {
    if (this.selected.length === 0 || this.loading) return;

    this.loading = true;
    this.error = '';
    this.addedToCart = false;

    const modalCart = window.theme.settings.cart_type === 'modal';
    const body = {
      items: this.selected.map((id) => ({ id, quantity: 1 })),
    };

    if (modalCart) {
      body.sections = 'cart-items,cart-footer,cart-item-count';
      body.sections_url = window.location.pathname;
    }

    fetch(window.theme.routes.cart_add_url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
    })
      .then((res) => res.json())
      .then((data) => {
        this.loading = false;
        if (data.status) {
          this.error =
            data.description || data.message || 'Something went wrong.';
          return;
        }
        this.addedToCart = true;
        document.body.dispatchEvent(
          new CustomEvent('shapes:cart:afteradditem', {
            bubbles: true,
            detail: { response: data },
          })
        );
        if (modalCart) {
          document.body.dispatchEvent(
            new CustomEvent('shapes:modalcart:afteradditem', {
              bubbles: true,
              detail: { response: data },
            })
          );
        }
      })
      .catch(() => {
        this.loading = false;
        this.error = 'Something went wrong adding these to your cart.';
      });
  },
}));

document.addEventListener('DOMContentLoaded', () => {
  // Guard against a double Alpine.start(): if it fires twice, every
  // `x-teleport` template (e.g. the cart/right-drawer in
  // snippets/right-drawer.liquid) gets processed twice and appends a
  // second, content-less copy to <body>, which then paints over the real
  // one — the cart drawer opens as a blank white panel. See P2-09 notes.
  if (window.__mudadAlpineStarted) return;
  window.__mudadAlpineStarted = true;
  Alpine.start();
});
